export function handleDisgoPassesButtonPress({
  isEnabled,
  onOpenPasses,
  onUnavailable,
}) {
  if (!isEnabled) {
    onUnavailable?.();
    return false;
  }

  onOpenPasses?.();
  return true;
}
